export default {"src":"/_next/static/media/cat-conventional-plan.a7b250d1.svg","height":48,"width":48};